export const environment = {
  production: true,
  //video upload
  component: 'FLIGHTTURNAROUND',
  area: 'Qa',
  customer: 'Qa',
  product: 'Qa',
  location: 'Qa',
  host: "https://qaapi.adr.avileap.com/api/AviLeap",
  socketHost: "https://qaapi.adr.avileap.com",
  analyticsHost: "https://qaapi.adr.avileap.com/api/analytics",
  analytics: "https://qaapi.adr.avileap.com/auth",
  base: "https://qaapi.adr.avileap.com",
  baseWithAPI: "https://qaapi.adr.avileap.com/api",
  publichost: "https://qaapi.adr.avileap.com/api/public",
  socketconnection:"/qasocket",
  weblink: "https://mqa.adr.avileap.com/",
};